/**
 * Date utils
 */
import format from 'date-fns/format';
import { DATE_FORMAT } from 'src/config/configString';
import type { LocalTime } from 'src/generated/services/TFinancialApi';

/**
 * formatDate
 */
export const formatDateString = (value: string, fallback = '-') => {
  if (!value) return fallback;
  return formatDate(new Date(value));
};

export const safeFormatDateString = (value: string, fallback = '-') => {
  if (!value) return fallback;
  try {
    return formatDate(new Date(value));
  } catch (error) {
    return value;
  }
};

export const formatDate = (value: Date, fallback = '-') => {
  if (!value) return fallback;
  return format(value, DATE_FORMAT);
};

export const newFormatDateString = (dateString: string): string => {
  if (!dateString) return dateString;
  return format(new Date(dateString), 'd-MMM-yyyy h:mma');
};

export const newFormatDateTimeString = (dateString: string): string => (dateString ? format(new Date(dateString), 'dd-MMM-yyyy HH:mm:ss') : '-');

/**
 * Formats LocalTime object to HH:mm format
 */
export const formatTimeDisplay = (time: LocalTime | string | undefined): string => {
  if (!time) return '-';
  if (typeof time === 'string') {
    const parts = time.split(':');
    if (parts.length >= 2) return `${parts[0].padStart(2, '0')}:${parts[1].padStart(2, '0')}`;
    return '-';
  }
  if (time.hour === undefined || time.minute === undefined) return '-';
  const hour = String(time.hour).padStart(2, '0');
  const minute = String(time.minute).padStart(2, '0');
  return `${hour}:${minute}`;
};
